import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useCopyValue } from '../../../hooks'
import Button, { BUTTON_HEIGHT_40 } from '../../Button'
import { QA_NAME_FIELD_VARIABLE_COPY_BUTTON } from '../FieldVariable.constants'

import CopyIcon from '../../../icons/copy.svg'

function FieldVariableCopyButton({ value }) {
  const { t } = useTranslation()

  const { copied, handleCopy } = useCopyValue({
    successNotificationKey: 'Notification.FieldVariableCopiedKey',
    value,
  })

  return (
    <Button.Contained
      isGrey
      beforeIconProps={{ Icon: CopyIcon }}
      disabled={copied}
      height={BUTTON_HEIGHT_40}
      qaName={QA_NAME_FIELD_VARIABLE_COPY_BUTTON}
      tooltip={
        copied
          ? t('FieldVariable.CopiedTooltipKey')
          : t('FieldVariable.CopyTooltipKey')
      }
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleCopy}
    />
  )
}

export default FieldVariableCopyButton
